import React from 'react';
import { Box, Divider, Text } from '@wix/design-system';
import { ConfirmSmall } from '@wix/wix-ui-icons-common/lazy';
import { Sso as SSO } from '@wix/wix-ui-icons-common/odeditor';
import s from './DomainInsight.module.scss';
import { DomainInsightSkeleton } from './DomainInsightSkeleton';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { DomainWithEllipsis } from '../DomainWithEllipsis';
import { LegalDisclaimer } from './LegalDisclaimer';
import SparklesGradient from '../../assets/images/SparklesGradient.svg?url';
export const DomainInsight = _ref => {
  let {
    domain,
    description,
    bullets,
    isLoading,
    sslCertificate = true,
    showLegalDisclaimer = true,
    withCard = true
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  if (!description && !(bullets != null && bullets.length) && !isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "SP5"
  }, /*#__PURE__*/React.createElement(Box, {
    borderRadius: withCard ? '12px' : undefined,
    padding: withCard ? 'SP4 SP7 SP7 SP7' : undefined,
    height: "max-content",
    width: "100%",
    boxShadow: withCard ? '-5px 6px 33px 0 rgba(0, 0, 0, 0.10)' : undefined
  }, isLoading ? /*#__PURE__*/React.createElement(DomainInsightSkeleton, {
    domain: domain,
    compact: !withCard
  }) : /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP6",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "SP3",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "3px",
    align: "left",
    verticalAlign: "middle",
    className: s.gradient
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("img", {
    src: SparklesGradient,
    alt: ""
  })), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, t('domain_search_suite.results.insight_widget.header'))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "3px"
  }, /*#__PURE__*/React.createElement(DomainWithEllipsis, {
    maxWidth: "350px",
    textComponent: Text,
    textComponentProps: {
      size: 'medium',
      weight: 'bold'
    }
  }, domain), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin"
  }, description)), Boolean(bullets == null ? void 0 : bullets.length) && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "7px"
  }, bullets == null ? void 0 : bullets.map((insight, index) => /*#__PURE__*/React.createElement(Box, {
    key: index,
    direction: "horizontal",
    gap: "7px",
    align: "left",
    verticalAlign: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "2px"
  }, /*#__PURE__*/React.createElement(ConfirmSmall, null)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, insight))))), sslCertificate ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    align: "left"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "top"
  }, /*#__PURE__*/React.createElement(SSO, {
    style: {
      transform: 'translateY(-2px)'
    }
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "2px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, t('domain_search_suite.results.insight_widget.ssl_header')), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, t('domain_search_suite.results.insight_widget.ssl_body'))))) : null)), !isLoading && showLegalDisclaimer ? /*#__PURE__*/React.createElement(Box, {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(LegalDisclaimer, null)) : null);
};
//# sourceMappingURL=DomainInsight.js.map